import {
    parseSelectFilterOptions,
    constructQueryParamName,
} from '../../util/search';

/* A chip has to say which condition it is, not just its value. "7", "5" and
 * "112" sitting in a row tell a shopper nothing — and an unexplainable filter
 * is exactly what makes an empty result look like a broken site. Prefix each
 * chip with the field's own label from the hosted config: "Fälgbredd: 7". */
const withFieldLabel = (field, value) => {
    const name = field?.filterConfig?.label || field?.label || '';
    return name ? `${name}: ${value}` : String(value);
};

export const getDynamicSelectedPills = (listingFieldsConfig, urlQueryParams, listingCategories = []) => {
    const pills = [];

    const categoryLevels = Object.keys(urlQueryParams)
        .filter(k => k.startsWith('pub_categoryLevel'));

    if (categoryLevels.length) {
        const buildCategoryMap = (cats, parentPath = []) => {
            let map = {};
            cats.forEach(cat => {
                const path = [...parentPath, cat];
                map[cat.id] = path;
                if (cat.subcategories?.length) {
                    map = { ...map, ...buildCategoryMap(cat.subcategories, path) };
                }
            });
            return map;
        };
        const categoryMap = buildCategoryMap(listingCategories);

        const lastLevelKey = categoryLevels.sort().pop();
        const selectedId = urlQueryParams[lastLevelKey];

        if (selectedId && categoryMap[selectedId]) {
            const path = categoryMap[selectedId];
            const label = path.map(p => p.name).join(' ');

            pills.push({
                key: 'category',
                value: path.map(p => p.id),
                label,
            });
        }
    }

    listingFieldsConfig.forEach(field => {
        const { key, filterConfig, schemaType, enumOptions, scope } = field;
        if (!filterConfig) return;

        const queryParamName = constructQueryParamName(key, scope);

        if (schemaType === 'enum' || schemaType === 'multi-enum') {
            const rawValue = urlQueryParams[queryParamName] || '';
            const selectedValues = parseSelectFilterOptions(rawValue);

            selectedValues.forEach(val => {
                const label = enumOptions?.find(opt => String(opt.option) === String(val))?.label;
                if (label) {
                    pills.push({
                        key,
                        value: val,
                        label: withFieldLabel(field, label),
                    });
                }
            });
        } else if (schemaType === 'long') {
            if (urlQueryParams[queryParamName] != null) {
                pills.push({
                    key,
                    value: urlQueryParams[queryParamName],
                    label: withFieldLabel(field, urlQueryParams[queryParamName]),
                });
            }
        } else if (schemaType === 'text') {
            if (urlQueryParams[queryParamName]) {
                pills.push({
                    key,
                    value: urlQueryParams[queryParamName],
                    label: withFieldLabel(field, urlQueryParams[queryParamName]),
                });
            }
        }
    });

    return pills;
};
